import api from 'Application/api/api';

const deleteProject = (signal, id) =>
	api.delete(`/projects/${id}`, {
		signal,
	});

export default deleteProject;
